export default "__VITE_ASSET__cfb37729__"